import { Directive, HostListener, Input } from "@angular/core";

@Directive({
  selector: '[customButtonSwitch]',
  standalone: false
})
export class CustomButtonSwitchDirective {

  @Input() isVisible: boolean = false;
  @Input() targetClass: string = 'LeftMenuSlot';

  constructor() {
  }

  @HostListener('click') removeClass(): void {
    const target = <HTMLElement>document.querySelector('.' + this.targetClass);
    if (this.isVisible) {
      target?.classList?.add('visible');
    } else {
      target?.classList?.remove('visible');
    }
  }
}
